import React from "react";

const GLOBAL_WATERMARK_TEXT = "GlobalChristianCommunity.com";

export default function SiteWatermark({ className = "" }) {
  const classes = ["site-watermark"];
  if (className) classes.push(className);

  return (
    <div className={classes.join(" ")} aria-hidden="true">
      <span>{GLOBAL_WATERMARK_TEXT}</span>
    </div>
  );
}
